<template>  
    <footer v-if="userInfo">
      <div class="footer-main"  >
        <a-flex>
          <div>
            <p class="title">用户中心</p>
            <ul>
              <li class="w1"><a @click="remind()">提醒中心</a></li>
              <li class="w1"><a @click="order()">订单管理</a></li>
              <li class="w1"><a @click="policy()">我的保单</a></li>
              <li class="w1"><a @click="claim()">理赔申请</a></li>
              <li class="w1"><a @click="account()">账户信息</a></li>
              <!-- <li class="w1"><a @click="invoice()">我的发票</a></li> -->
              <li class="w1"><a @click="common()">常用信息</a></li>
              <li class="w1"><a @click="occupation()">职业类别</a></li>
<!--              <li class="w1"><a @click="download()">表单下载</a></li>-->
            </ul>
          </div>
          <div class="footer-pro"  v-if="data.length > 0">
            <p class="title">产品中心</p>
             <ul>
              <li class="w2" v-for="(item, key) in data">
                <router-link :to="{ name: 'insure', params: { code: item.code }}">
                  {{ item.name }}
                </router-link>
              </li>
            </ul>
          </div>
        </a-flex>
      </div>
    </footer>
<!--    <div v-if="userInfo || !uri[1]">-->
    <div>
      <p class="footer-bah">备案号：陕ICP备2024057448号</p>
    </div>
</template>
<script setup>
import {ref} from 'vue'
import {productListByType} from '/@/api/Product.api'
import {getAuthCache} from "@/utils/utils";
import {USER_INFO_KEY} from "@/enums/cacheEnum";
let userInfo = getAuthCache(USER_INFO_KEY)
let uri = window.location.pathname
uri = uri.split('/')

const data = ref([])
const getProductListByType = () =>{
  productListByType().then((res) => {
    data.value = res
  })
}
if(userInfo){
  getProductListByType()
}
</script>
<script>
import {detail} from "@/api/MemberAccount.api";
import {getUserInfo} from '@/api/Login.api';
import router from "@/router";

export default {
  methods: {
    remind(){
      const routeUrl = router.resolve({ name: 'remind' });
      window.open(routeUrl.href,'_self');
      // this.$router.push({ name: 'remind' });
    },
    order(){
      const routeUrl = router.resolve({ name: 'orderList' });
      window.open(routeUrl.href,'_self');
      // this.$router.push({ name: 'orderList' });
    },
    policy(){
      const routeUrl = router.resolve({ name: 'policy' });
      window.open(routeUrl.href,'_self');
      // this.$router.push({ name: 'policy' });
    },
    claim(){
      const routeUrl = router.resolve({ name: 'claim' });
      window.open(routeUrl.href,'_self');
      // this.$router.push({ name: 'claim' });
    },
    claiminfo(){
      const routeUrl = router.resolve({ name: 'claiminfo' });
      window.open(routeUrl.href,'_self');
      // this.$router.push({ name: 'claiminfo' });
    },
    claimSq(){
      const routeUrl = router.resolve({ name: 'claimSq' });
      window.open(routeUrl.href,'_self');
      // this.$router.push({ name: 'claimSq' });
    },
    showDetail(){
      const routeUrl = router.resolve({ name: 'remind' });
      window.open(routeUrl.href,'_self');
      this.$router.push({ name: 'detail' });
    },
    account(){
      const routeUrl = router.resolve({ name: 'account' });
      window.open(routeUrl.href,'_self');
      // this.$router.push({ name: 'account' });
    },
    invoice(){
      const routeUrl = router.resolve({ name: 'invoice' });
      window.open(routeUrl.href,'_self');
      // this.$router.push({ name: 'invoice' });
    },
    common(){
      const routeUrl = router.resolve({ name: 'common' });
      window.open(routeUrl.href,'_self');
      // this.$router.push({ name: 'common' });
    },
    occupation(){
      const routeUrl = router.resolve({ name: 'occupation' });
      window.open(routeUrl.href,'_self');
      // this.$router.push({ name: 'occupation' });
    },
    download(){
      const routeUrl = router.resolve({ name: 'download' });
      window.open(routeUrl.href,'_self');
      // this.$router.push({ name: 'download' });
    },
  }
}

</script>
<style scoped>
footer{
  padding: 25px 0;  
  background: #f0f2f5; 
} 
.footer-main{
  width: 1400px;
  margin: 0 auto;
  padding-left:130px;
}
.footer-main .title{
  margin-bottom: 28px;
  font-family: PingFangSC-Regular, PingFang SC, sans-serif;
  font-size: 14px;
  font-weight: 800;
  line-height: 14px;
  color: #333;
}
.footer-main ul{
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  align-content: flex-start;
  max-height: 170px; 
  padding-left: 0;
}
.footer-main ul li{
  height: 14px;
  margin-bottom: 20px;
  line-height: 14px;
  list-style: none;
} 
.footer-main ul li.w2{
  margin-right:20px;
}
.w1{width: 105px;}
/*.w2{width: 300px;}*/
.footer-main ul li a{
  font-size: 14px;
  color: #9499a0; 
} 
.footer-pro{
  padding-left: 60px;
}
.footer-bah{
  padding-top: 50px;
  padding-bottom: 40px;
  font-family: MicrosoftYaHei, sans-serif;
  font-size: 14px;
  color: #74829e;
  text-align: center;
  background: #f0f2f5; 
}
</style>

